/**
 * @enum {number} SecurityLevels
 *
 * Silent = 0 Silently grants the request with no user interation.
 * App = 1 Requires user approval for every application.
 * Counterparty = 2 Requires user approval per counterparty per application.
 */
export var SecurityLevels;
(function (SecurityLevels) {
    SecurityLevels[SecurityLevels["Silent"] = 0] = "Silent";
    SecurityLevels[SecurityLevels["App"] = 1] = "App";
    SecurityLevels[SecurityLevels["Counterparty"] = 2] = "Counterparty";
})(SecurityLevels || (SecurityLevels = {}));
//# sourceMappingURL=Wallet.interfaces.js.map